<template>
    <div>
        <div class="content-wrapper" style="padding-bottom: 0">
            <h4 v-html="separateUrlTeams"></h4>
            <div><b>{{ $t('league') }}: </b><a :href="'/league/' + data.league_id" target="_blank">{{ data.league }}</a></div>
            <div><b>{{ $t('date') }}: </b>{{ data.event_start_time }}</div>
            <div><b>{{ $t('event_id') }}: </b>{{ data.id }}</div>
        </div>
        <div class="content-wrapper" style="padding-bottom: 0">
            <div class="col-12 ">
                <div class="filters-wrapper">
                    <template v-for="markets in filters">
                        <template v-for="(type, index) in markets">
                            <div class="row">
                                <template v-for="(item, index) in type">
                                    <div class="single-filter">
                                        <div class="dropdown">
                                            <button
                                                id="odds-odds-table"
                                                class="btn btn-filter"
                                                :class="item.active ? 'applied' : ''"
                                                @click.prevent="applyFilter(item)">
                                                {{ item.title }}
                                            </button>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </template>
                </div>
            </div>
        </div>
        <pinnacle-odds-datatable :game_id='data.id' :custom_filters="filters"></pinnacle-odds-datatable>
    </div>
</template>

<script>
    import * as actions from "../../../../Config/ApiUrl";
    import {urlGenerator} from "../../../../Helpers/AxiosHelper";

    export default {
        name: "ViewGame",
        props: ['data', 'filters'],
        data() {
            return {
                separateUrlTeams: this.data.name,
                componentLoader: false,
                preloader: false,
                activeParams: {},
            }
        },
        created() {
            if (this.data) {
                this.separateUrlTeams = "<a href='/team/" + this.data.team_1_id + "' target='_blank'>" + this.data.team1 + "</a> vs <a href='/team/" + this.data.team_2_id + "' target='_blank'>" + this.data.team2 + "</a>";
            }
            let uri = window.location.href.split('?');
            if(uri.length === 2) {
                let vars = uri[1].split('&');
                let getVars = {};
                let tmp = '';
                vars.forEach(function (v) {
                    tmp = v.split('=');
                    if (tmp.length === 2)
                        getVars[tmp[0]] = tmp[1];
                });
                this.activeParams = getVars;
                console.log(getVars);
            }
        },
        methods: {
            applyFilter(item) {

                // https://oddsalert.eu/game/272447?custom_filters=asian.set.-1.5,asian.set.1.5&per_page=50&page=1
                // check if the filter is already applied from the url using custom_filters

                // get url params
                let uri = window.location.href.split('?');
                let urlParams = {};
                if(uri.length === 2) {
                    let vars = uri[1].split('&');
                    let getVars = {};
                    let tmp = '';
                    vars.forEach(function (v) {
                        tmp = v.split('=');
                        if (tmp.length === 2)
                            getVars[tmp[0]] = tmp[1];
                    });
                    urlParams = getVars;
                }

                // check if the filter is already applied
                let customFilters = urlParams.custom_filters ? urlParams.custom_filters.split(',') : [];
                let filterIndex = customFilters.indexOf(item.id);
                if(filterIndex !== -1) {
                    customFilters.splice(filterIndex, 1);
                } else {
                    customFilters.push(item.id);
                }

                // update url
                let url = uri[0] + '?';
                if(customFilters.length > 0) {
                    url += 'custom_filters=' + customFilters.join(',');
                }
                if(urlParams.per_page) {
                    url += '&per_page=' + urlParams.per_page;
                }
                if(urlParams.page) {
                    url += '&page=' + urlParams.page;
                }

                // redirect to the url
                window.location.href = url;
            }
        }
    }
</script>